/**
 * Zero table definition for habit_nutrition_food.
 */

import { json, number, string, table } from "@rocicorp/zero";

export const habitNutritionFood = table("habit_nutrition_food")
  .columns({
    id: string().optional(),
    name: string(),
    normalizedName: string().from("normalized_name"),
    description: string().optional(),

    // Core macros
    calories: number(),
    protein: number(),
    fat: number(),
    carbs: number(),
    fiber: number(),
    saturatedFat: number().from("saturated_fat"),

    // Source tracking per macro
    caloriesSource: string().from("calories_source"),
    caloriesSourceId: string().optional().from("calories_source_id"),
    caloriesConfidence: number().from("calories_confidence"),
    proteinSource: string().from("protein_source"),
    proteinSourceId: string().optional().from("protein_source_id"),
    proteinConfidence: number().from("protein_confidence"),
    fatSource: string().from("fat_source"),
    fatSourceId: string().optional().from("fat_source_id"),
    fatConfidence: number().from("fat_confidence"),
    carbsSource: string().from("carbs_source"),
    carbsSourceId: string().optional().from("carbs_source_id"),
    carbsConfidence: number().from("carbs_confidence"),
    fiberSource: string().from("fiber_source"),
    fiberSourceId: string().optional().from("fiber_source_id"),
    fiberConfidence: number().from("fiber_confidence"),
    saturatedFatSource: string().from("saturated_fat_source"),
    saturatedFatSourceId: string().optional().from("saturated_fat_source_id"),
    saturatedFatConfidence: number().from("saturated_fat_confidence"),

    // Classification
    foodGroup: string().from("food_group"),
    tags: json<string[]>(),
    compatibleModifiers: json<string[]>().from("compatible_modifiers"),
    enrichmentStatus: string().optional().from("enrichment_status"),

    // Timestamps
    createdAt: number().optional().from("created_at"),
    updatedAt: number().optional().from("updated_at"),
  })
  .primaryKey("id");
